module.exports = __webpack_public_path__ + "img/3.30f92aa6.png";